import { TaskSettlementStatus } from '@admiin-com/ds-graphql';
import {
  WBBox,
  WBToggleButtonGroup,
  WBRoundedToggleButton,
} from '@admiin-com/ds-web';
import { useTheme, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
export const TaxPaymentRadioButtons = ({
  value,
  onChange,
}: {
  value: TaskSettlementStatus;
  onChange: (value: TaskSettlementStatus) => void;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <WBBox mt={2}>
      <WBToggleButtonGroup
        size="medium"
        fullWidth={isMobile}
        exclusive
        sx={{ mt: 0, gap: 1 }}
        defaultValue={TaskSettlementStatus.PAYABLE}
        label={t('Tax Payable', { ns: 'taskbox' })}
        onChange={(e, value) => onChange(value)}
      >
        {[
          TaskSettlementStatus.PAYABLE,
          TaskSettlementStatus.REFUNDABLE,
          TaskSettlementStatus.NIL,
        ].map((key) => {
          return (
            <WBRoundedToggleButton
              value={key}
              key={key}
              selected={key === value}
            >
              {t(key, {
                ns: 'taskbox',
              })}
            </WBRoundedToggleButton>
          );
        })}
      </WBToggleButtonGroup>
    </WBBox>
  );
};
